

































import {
    Component, Mixins, Model, Prop, Watch,
} from 'vue-property-decorator';
import { filter, findIndex, map } from 'lodash';
import { ImageInfo } from '@luxtag/papybase';
import InsertPhotoDialogPhotosItem from '@/components/global/InsertPhotoDialog/InsertPhotoDialogPhotosItem.vue';
import PhotoIntegrationMixin from '@/mixins/vue/PhotoIntegrationMixin';
import papybaseConfig from '@/plugins/papybase/papybaseConfig';

@Component({
    components: {
        InsertPhotoDialogPhotosItem,
    },
})
export default class InsertPhotoDialogPhotos extends Mixins(PhotoIntegrationMixin) {
    @Model('update:photos', { type: Array }) readonly value!: string[];
    @Prop() readonly dialogStatus!: boolean;

    public showText = true;

    public columnNumber = 4;

    public async created() {
        this.integratePhotoListFromBackEndToLocalStorage().catch((err) => {
            console.error(err);
        });
    }

    public onChecked(src: string) {
        if (!this.$store.getters.isMultipleImage) {
            this.value.shift();
        }
        this.value.push(src);
    }

    public onUnchecked(src: string) {
        const theIndex = findIndex(this.value, photo => photo === src);
        if (this.$store.getters.isMultipleImage) {
            this.value.splice(theIndex, 1);
        } else if (theIndex !== -1) this.value.shift();
    }

    public constructUrl(path: string) {
        return `${papybaseConfig.baseURL}/${path}`;
    }

    get photos(): ImageInfo[] {
        return (this.$store.getters.getPhotos as ImageInfo[]).slice(0, 20);
    }

    get photoColumns() {
        const photoColumns: any[] = [];
        // set the number of colums
        for (let i = 0; i < this.columnNumber; i += 1) {
            photoColumns.push([]);
        }

        for (let i = 0; i < this.photos.length; i += 1) {
            photoColumns[i % 4].push(this.photos[i]);
        }

        return photoColumns;
    }

    @Watch('dialogStatus')
    private onDialogStatusChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.integratePhotoListFromBackEndToLocalStorage().catch((err) => {
                console.error(err);
            });
        }
    }
}
